import { render, staticRenderFns } from "./StrategyPanels.vue?vue&type=template&id=10cd7684&scoped=true"
import script from "./StrategyPanels.vue?vue&type=script&lang=js"
export * from "./StrategyPanels.vue?vue&type=script&lang=js"
import style0 from "./StrategyPanels.vue?vue&type=style&index=0&id=10cd7684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cd7684",
  null
  
)

export default component.exports